import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const Modal = props => {
    const {
        modalActive,
        hideModal,
        handlePress,
        selectEmployee,
        employeeData,
    } = props;

    const Image = props => {
        const { avatar, description } = props;
        return (
            avatar &&
            avatar.sizes.thumbnail && (
                <div className="modal__image">
                    <img
                        className="modal__image--circle"
                        draggable="false"
                        width="155"
                        height="155"
                        src={avatar.sizes.thumbnail}
                        alt={description}
                    />
                </div>
            )
        );
    };

    const Name = props => {
        const { name, lastName, title } = props;
        return (
            <div className="modal__image--content">
                {name && lastName && (
                    <h2>
                        <span>{name}</span> <span>{lastName}</span>
                    </h2>
                )}
                {title && <h3>{title}</h3>}
            </div>
        );
    };

    const Bio = props => {
        const { info } = props;
        return (
            info && (
                <div className="modal__content">{ReactHtmlParser(info)}</div>
            )
        );
    };

    const UpdateModalContent = () => {
        const showSelected = employeeData.filter(
            value => value.employee_name === selectEmployee
        );
        const showData = showSelected.map((value, index) => {
            return (
                <div className="content-container" key={index}>
                    <div className="row modal__wrapper">
                        <div className="col-md-12">
                            <header className="modal__header">
                                <Image
                                    avatar={value.employee_avatar}
                                    description={value.employee_name}
                                />

                                <Name
                                    name={value.employee_name}
                                    lastName={value.employee_lastname}
                                    title={value.employee_title}
                                />
                            </header>
                        </div>
                        <div className="col-md-12">
                            <Bio info={value.employee_bio} />
                            <div className="modal__shareitems">
                                {(value.employee_linkedinurl ||
                                    value.employee_mail) && (
                                    <h4>
                                        {`Connect with ${value.employee_name}`}
                                    </h4>
                                )}
                                <div className="share-buttons">
                                    <ul>
                                        {value.employee_linkedinurl && (
                                            <li>
                                                <a
                                                    href={
                                                        value.employee_linkedinurl
                                                    }>
                                                    <i className="icon icon-in_icon"></i>
                                                </a>
                                            </li>
                                        )}

                                        {value.employee_mail && (
                                            <li>
                                                <a
                                                    href={`mailto:${value.employee_mail}`}>
                                                    <i className="icon icon-mail_icon" />
                                                </a>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
        return showData;
    };

    return (
        <section className={`modal ${modalActive && 'active'}`}>
            <div className="modal__inner">
                <span
                    onClick={hideModal}
                    onKeyPress={handlePress}
                    className="btn btn__close">
                    <div
                        className={`hamburger hamburger--spin ${
                            modalActive ? 'active' : 'hidden'
                        }`}>
                        <div className="hamburger-box">
                            <div className="hamburger-inner" />
                        </div>
                    </div>
                </span>
                {employeeData && UpdateModalContent()}
            </div>
        </section>
    );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Pages/People/Modal.jsx